import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import { banners } from "../../common/types";
import observeBanners from "../observeBanners";
export default class HeaderBanner extends Component {
  banners = [];
  stop = null;
  oninit(vnode) {
    super.oninit(vnode);
    try {
      this.banners = banners(app.data.xgayBanners).filter(banner => banner.attributes.enabled);
    } catch {
      // Missing or invalid bootstrap data must not interrupt the forum.
      this.banners = [];
    }
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.observe();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.observe();
  }
  onremove(vnode) {
    super.onremove(vnode);
    this.stop?.();
  }
  observe() {
    if (!this.stop && this.banners.length) this.stop = observeBanners(this.element);
  }
  click(banner) {
    if (banner.attributes.linkType !== "internal") return;
    void fetch(app.forum.attribute("apiUrl") + "/banners/" + banner.id + "/click", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "X-CSRF-Token": app.session.csrfToken
      }
    }).catch(() => {});
  }
  view() {
    return m("div", {
      className: "XgayBanners header-banner",
      hidden: !this.banners.length
    }, this.banners.map(banner => {
      const a = banner.attributes;
      return m("div", {
        key: banner.id,
        className: "XgayBanners-item XgayBanners-item--" + a.type,
        "data-banner-id": banner.id
      }, a.type === "html" ? m.trust(a.html ?? "") : a.href ? m("a", {
        className: "XgayBanner-link",
        href: a.href,
        target: a.openNewTab ? "_blank" : undefined,
        rel: a.isSponsored ? "sponsored nofollow noopener" : "noopener",
        onclick: () => this.click(banner),
        onauxclick: event => {
          if (event.button === 1) this.click(banner);
        }
      }, m("img", {
        className: "my-header-banner-image",
        src: a.imageUrl ?? "",
        alt: ""
      })) : m("img", {
        className: "my-header-banner-image",
        src: a.imageUrl ?? "",
        alt: ""
      }));
    }));
  }
}
flarum.reg.add('xgay-banner', 'forum/components/HeaderBanner', HeaderBanner);